module.exports = {
  language: 'Thai',
  applierApplicationCenter: {
    selectCenterTip: ' '
  },
  multiplePage: {
    moreInfomation: ' ',
    recommendedServices: ' '
  },
  checkoutConfirm: {
    ordered: ' ',
    purchased: ' '
  },
  personal: {
    purgePopupContent:
      'ขออภัย เนื่องจากใบสมัครของท่านถูกลบออกเนื่องจากนโยบายด้านความปลอดภัย ท่านสามารถติดต่อกลับ หากท่านประสงค์ที่จะสมัครเร็วๆนี้'
  },
  login_maximum: {
    errorContent: 'ขออภัย คุณเข้าสู่ระบบครบจำนวนครั้งสูงสุดในวันนี้ โปรดลองใหม่ในวันถัดไป'
  },
  nationalityKay: 'th-th',
  noneSelectedText: 'โปรดเลือก',
  multiselect: {
    deselect: 'กด Enter เพื่อลบ',
    select: 'กด Enter เพื่อเลือก',
    selected: 'ที่เลือก'
  },
  upload_failed: 'การอัปโหลดล้มเหลว โปรดลองอีกครั้ง',
  due_time: 'ครบกำหนด',
  requirement: 'ความต้องการ',
  something_went_wrong_please_retry: 'อะไรบางอย่างผิดปกติ กรุณาลองอีกครั้ง',
  valid_rediret_home_page_popup_content:
    "เกิดข้อยกเว้นการเข้าสู่ระบบ คุณกำลังพยายามไปที่หน้าแรกของ [ {country} - {center} ] เพื่อเข้าสู่ระบบหรือไม่? ถ้าใช่ โปรดคลิกที่ 'ยืนยัน'; ถ้าไม่ใช่ โปรดคลิก 'ยกเลิก' เพื่อเลือกอีกครั้ง",
  invalid_rediret_home_page_popup_content: 'เกิดข้อยกเว้นในการเข้าสู่ระบบ โปรดเลือกประเทศและสถานที่เพื่อดำเนินการต่อ',
  'Temporarily not available': 'ไม่สามารถใช้ได้ชั่วคราว'
};
